import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GameDataInternal, Setting } from '../../interfaces/cards.interface';

import * as CryptoJS from 'crypto-js';
import { LoopBackAuth } from '../../Api';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class LogicService {
    apiKey = 'kVpRb#M:RE45?$Df';
    userId = 0;

    constructor(private http: HttpClient,
                private storage: StorageService,
                private auth: LoopBackAuth) {
    }

    setGameData(gameLevel: GameDataInternal) {
        this.userId = this.auth.getCurrentUserId();
        if (!this.userId) {
            this.userId = 0;
        }
        // if (!this.userId) {
        //     console.log('setGameData Can read user Id ');
        //     return;
        // }
        if (!gameLevel) {
            console.log('setGameData Can read gameData ');
            return;
        }
        const address = gameLevel.gameAddress + this.userId;
        this.storage.set(address, JSON.stringify(gameLevel)).then((val: any) => {
            // console.log('setGameData Success ');
        }).catch((e) => {
            console.log('setGameData error ', e);
        });
    }

    getGameData(address) {
        return new Promise((resolve, reject) => {
            this.userId = this.auth.getCurrentUserId();
            if (!this.userId) {
                this.userId = 0;
            }
            // if (!this.userId) {
            //     console.log(' getGameData Can read user Id ');
            //     reject();
            // }
            if (!address) {
                console.log('setGameData Can read address ');
                reject();
            }
            let gameLevel: GameDataInternal;
            const addressSave = address + this.userId;
            this.storage.get(addressSave).then((val: any) => {
                if (val) {
                    gameLevel = JSON.parse(val) as GameDataInternal;
                    // console.log('getGameData ', gameLevel);
                    resolve(gameLevel);
                } else {
                    resolve('ok');
                }

            }).catch((e) => {
                console.log(e);
                reject();
            });
        });
    }

    getSetting() {
        return new Promise((resolve) => {
            let gameSettings: Setting = {
                sound: true,
                language: 'vi',
                lock: 'lock',
                day: 0,
                kind: 'day'
            };
            try {
                this.userId = this.auth.getCurrentUserId();
                if (!this.userId) {
                    this.userId = 0;
                }
                const address = 'setting' + this.userId;
                this.storage.get(address).then((val: any) => {
                    if (val) {
                        try {
                            const data = CryptoJS.AES.decrypt(val, this.apiKey).toString(CryptoJS.enc.Utf8);
                            if (data) {
                                gameSettings = JSON.parse(data) as Setting;
                                resolve(gameSettings);
                                return;
                            }
                        } catch (e) {
                            console.log('Decrypt setting error', e);
                        }
                    }
                    resolve('');
                }).catch((e) => {
                    console.log('logicService getSetting storage error', e);
                    resolve('');
                });
            } catch (e) {
                console.log('logicService getSetting unexpected error', e);
                resolve('');
            }
        });
    }

    setSetting(gameSettings: Setting) {
        return new Promise((resolve, reject) => {
            this.userId = this.auth.getCurrentUserId();
            if (!this.userId) {
                this.userId = 0;
            }
            const result = gameSettings;
            const setting = JSON.stringify(gameSettings);
            const dataSave = CryptoJS.AES.encrypt(setting, this.apiKey).toString();
            const address = 'setting' + this.userId;
            this.storage.set(address, dataSave).then((val: any) => {
                if (val) {
                    // console.log('setSetting Success ', val);
                    resolve(result);
                } else {
                    reject();
                }
            }).catch((e) => {
                console.log('setSetting error ', e);
                reject();
            });
        });
    }
}
